import { useEffect, useRef } from "react";

// Renders image to canvas so the src URL isn't exposed in the DOM.
// Blocks right-click and drag.
export default function ProtectedImage({ src, style, className }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!src) return;
    const img = new Image();
    img.onload = () => {
      const canvas = canvasRef.current;
      if (!canvas) return;
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      // Use CSS aspect-ratio so the canvas scales responsively
      canvas.style.aspectRatio = `${img.naturalWidth} / ${img.naturalHeight}`;
      canvas.getContext("2d").drawImage(img, 0, 0);
    };
    img.src = src;
  }, [src]);

  return (
    <canvas
      ref={canvasRef}
      className={className}
      style={{ display: "block", width: "100%", userSelect: "none", ...style }}
      onContextMenu={(e) => e.preventDefault()}
    />
  );
}
